import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';

export function ConfirmationDialog({ open, onClose, title, content, action, cancelTitle, actionTitle, loading }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ minWidth: 550 }}>
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{cancelTitle || 'خیر'}</Button>
          <Button onClick={action} disabled={loading} autoFocus variant="contained" sx={{ color: '#eee' }}>
            {actionTitle || 'بله'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
